module.exports = __webpack_public_path__ + "images/kawasaki_smalldd74d26342f852d4032ca9bc9c2082fe.png";